import { SpaceSummaryRail } from "@/react/components/Spaces/AiSummary/SpaceSummaryRail";
import { useRailbar } from "@/react/hooks/chatsV2/useRailbar";
import { useCurrentSpaceContext } from "@circle-react/contexts";

export const ChatSpaceSummary = () => {
  const { data: space } = useCurrentSpaceContext();
  const { shouldShowRailBar, dateRange, closeSpaceSummaryRailbar } =
    useRailbar();

  if (!space) return null;

  return (
    <SpaceSummaryRail
      isOpen={shouldShowRailBar}
      onClose={closeSpaceSummaryRailbar}
      space={space}
      dateRange={dateRange}
      type="chat"
      shouldHideRailbarDragger={false}
    />
  );
};
